var exports = {
  "root": "x24da60e8--c8940d--root",
  "desktop": "x24da60e8--c8940d--desktop",
  "name": "x24da60e8--c8940d--name",
  "labels": "x24da60e8--c8940d--labels",
  "label": "x24da60e8--c8940d--label",
};

module.exports = exports;
